'use client';

import { sizeOptions } from "./constants.js";
const validateSize = (size) => {
  if (sizeOptions.find((i) => i === size)) {
    return size;
  }
  return void 0;
};
export {
  validateSize
};
